<template>
  <section class="p-enginemonitor">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="monitor-wrap">
        <section class="c-mt-84 monitor-title">
          <p class="c-fs-32 c-mb c-fw-b c-c-text-color-dark">分布式轮询引擎</p>
          <p class="c-fs-16 c-mt-36 c-mb-56 c-lh-38 c-ta-j">MonitorWay分布式轮询引擎在大规模的监控环境中，负载均衡多个 MonitorWay 服务器间的数据轮询压力,提供分布式部署数据采集方案。</p>
          <img src="../../assets/monitor/engine.jpg" class="c-cs-p" preview="monitor-engine"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-84">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">MonitorWay 分布式轮询引擎概览</span>
          </div>
          <div class="c-bc-white c-fs-14 c-c-text-grey c-lh-36 c-mt-40 c-pt-56 c-pl-92 c-pb-128 c-p-r">
            <ul>
              <li>支持 100+ 轮询引擎的分布式部署</li>
              <li>轮询引擎与平台通信隧道加密</li>
              <li>单个轮询引擎可支撑 1000+ 资产的监控</li>
            </ul>
            <img src="../../assets/monitor/engine-pic.png" class="c-pr-40 pic">
          </div>
        </section>
        <section class="c-pb-164 features">
          <div class="c-d-f c-ai-c c-mt-80">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">功能介绍</span>
          </div>
          <div class="c-d-f c-jc-sb c-fw-w c-mt-40 features-wrap">
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet11.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">分布式集群部署</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">在大规模的监控环境中，负载均衡多个 MonitorWay 服务器间的数据轮询压力，从而达到数万个资产秒级监控目标。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/ip8.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">跨地域管理</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">对于跨地域的用户，可在不同的地域部署 MonitorWay 分布式轮询引擎，实现本地化数据采集，节省广域网传输带宽，提升监控数据的准确性。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/ip3.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">高安全性</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">MonitorWay 分布式轮询引擎与 MonitorWay 服务器之间采用加密隧道通信，避免了信息传输环节的数据泄露问题。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet5.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">灵活的分权分级</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">可灵活的设置 MonitorWay 分布式轮询引擎的机构/部门，用户组，负责人的归属，实现指定机构、人、用户组才能使用该轮询引擎的功能。</p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width monitor-wrap-mobile">
        <section class="c-mt-40 monitor-title">
          <p class="c-fs-19 c-fw-b c-c-text-color-dark">分布式轮询引擎</p>
          <p class="c-fs-12 c-mt-16 c-mb-24 c-lh-22 c-ta-j">MonitorWay 分布式轮询引擎在大规模的监控环境中，负载均衡多个 MonitorWay 服务器间的数据轮询压力,提供分布式部署数据采集方案。</p>
          <img src="../../assets/monitor/engine.jpg" preview="monitor-engine1"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">MonitorWay 分布式轮询引擎概览</span>
          </div>
          <div class="c-bc-white c-fs-13 c-c-text-grey c-lh-28 c-mt-24 c-ptb-20 c-pl-36 c-pr-16 c-boxshadow">
            <ul>
              <li>支持 100+ 轮询引擎的分布式部署</li>
              <li>轮询引擎与平台通信隧道加密</li>
              <li>单个轮询引擎可支撑 1000+ 资产的监控</li>
            </ul>
          </div>
        </section>
        <section class="features">
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">功能介绍</span>
          </div>
          <div class="c-mt-24 features-wrap">
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/internet11.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">分布式集群部署</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">在大规模的监控环境中，负载均衡多个 MonitorWay 服务器间的数据轮询压力，从而达到数万个资产秒级监控目标。</p>
                </div>
              </div>
            </div>
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/ip8.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">跨地域管理</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">对于跨地域的用户，可在不同的地域部署 MonitorWay 分布式轮询引擎，实现本地化数据采集，节省广域网传输带宽，提升监控数据的准确性。</p>
                </div>
              </div>
            </div>
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/ip3.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">高安全性</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">MonitorWay 分布式轮询引擎与 MonitorWay 服务器之间采用加密隧道通信，避免了信息传输环节的数据泄露问题。</p>
                </div>
              </div>
            </div>
            <div class="c-mb-32 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/internet5.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">灵活的分权分级</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">可灵活的设置 MonitorWay 分布式轮询引擎的机构/部门，用户组，负责人的归属，实现指定机构、人、用户组才能使用该轮询引擎的功能。</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: 'engine',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
.p-enginemonitor {
  @media screen and (min-width: 1180px) {
    min-height: calc(100vh - 90px - 525px);
    background: url('../../assets/monitor/monitor-bg.png') no-repeat;
    background-position: bottom;
    background-size: 100%;
  }
  .monitor-wrap {
    width: 1180px;
    margin: 0 auto;
    .monitor-title {
      img {
        height: 417px;
      }
    }
    .pic {
      position: absolute;
      right: 0;
      top: -70px;
    }
    .features {
      .features-wrap {
        .features-item {
          width: calc(50% - 7px);
          padding: 44px 54px;
          margin-bottom: 14px;
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
          border-radius: 1px;
          img {
            width: 18%;
          }
        }
      }
    }
  }
  .monitor-wrap-mobile {
    .monitor-title {
      img {
        // height: 202px;
        width: 100%;
      }
    }
    .features {
      .features-wrap {
        padding-bottom: 25px;
        .features-item {
          width: 100%;
          padding: 25px 16px;
          background: white;
          text-align: justify;
          img {
            width: 38px;
            height: 38px;
            object-fit: contain;
          }
        }
      }
    }
  }
}
</style>
